module.exports = __webpack_public_path__ + "img/angola.c40aec9.webp";